module.exports = __webpack_public_path__ + "static/media/taylor-momsen-lose.91e1c84b.jpg";